import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import { bgBlur } from "../../../utils/cssStyles";
import AccountPopover from "./AccountPopover";
import NotificationsPopover from "./NotificationsPopover";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ProductName from "./ProductName";
import React, { useState, useEffect } from 'react';
import { fetchAccountDetails } from "../../../store/accountSlice";

const NAV_WIDTH = 280;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 82;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  // boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%) 0px 4px 5px 0px rgb(0 0 0 / 14%) 0px 1px 10px 0px rgb(0 0 0 / 12%)',
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));
  const { emailData, emailStatus } = useSelector((state) => state.email);

  const [accountDetails, setAccountDetails] = useState({
    customer_name: '',
    customer_id: '',
    products: '',
    client_status: ''
  });

  const dispatch = useDispatch();
  
  const {
    data,
    customer_name,
    customer_id,
    products,
    contact_person,
    contact_email,
    contact_number,
    session_response,
    session_flag,
    status,
    error
  } = useSelector((state) => state.account)

  useEffect(() => {
    dispatch(fetchAccountDetails());
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      if (session_flag) {
        // setSessionResponse(session_response);
        // setSessionFlag(true);
      } else {
        setAccountDetails(data);
        // setEmail(contact_email);
        // setContactPerson(contact_person);
        // setContactNumber(contact_number);
      }
    }
  }, [data]);

  // useEffect(() => {
  //   const fetchAccountDetails = async () => {
  //     try {
  //       const response = await fetch('/meonsupport/account_detail', {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       });
  //       const data = await response.json();
  //       setAccountDetails(data);
  //     } catch (error) {
  //     }
  //   };

  //   fetchAccountDetails();
  // }, []);

  return (
    <StyledRoot style={{boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'}}>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: "text.primary",
            display: { lg: "none" },
          }}
        >
          <Icon icon="eva:menu-2-fill" />
        </IconButton>

        {/* <Typography sx={{display: isBelow768 ? "none" : ""}} color={"black"} variant="h6">
          {emailData[1]}
        </Typography> */}

        <ProductName productName={products} />

        <Box sx={{ flexGrow: 1 }} />
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 2,
          }}
        >
          <AccountPopover accountDetails={accountDetails} />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}